import { useLang } from '@/app/utils/useLang';
import gtm from '@/utils/gtm';
import EcoImg from 'eco-design/base/eco-img';
import Arrow from '../OnePicture/arrow';
import styles from './index.module.scss';

const OnePicture: React.FC = () => {
    const { t } = useLang('OnePicture');

    let items = [
        {
            title: t('title1'),
            desc: t('desc1'),
            href: '#Output',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1772422983658/c1.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1772435434371/c1_m.jpg',
        },
        {
            title: t('title2'),
            desc: t('desc2'),
            href: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1772422114585/c2.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1772435434802/c2_m.jpg',
        },
        {
            title: t.rich('title3', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc3'),
            href: '#d3m-automotive',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1772422114773/c3.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1772435434686/c3_m.jpg',
        },
        {
            title: t('title4'),
            desc: t('desc4'),
            href: '',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1772422114948/c4.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1772435433754/c4_m.jpg',
        },
        {
            title: t.rich('title5', {
                sup: (text: string) => <sup>{text}</sup>,
            }),
            desc: t('desc5'),
            href: '#ChargeUp',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1772422115184/c5.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1772435433953/c5_m.jpg',
        },
        {
            title: t('title6'),
            desc: t('desc6'),
            href: '#PriorityOutputsBlock',
            pc: 'https://websiteoss.ecoflow.com/upload/image/1772422115380/c6.jpg',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1772435482774/c6_m.jpg',
        },
    ];
    const handleScrollInToView = (href: string, className: string) => {
        const element = document.getElementById(href.replace('#', ''));
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }

        gtm.push({
            __btn_id1: `one-picture .${className}`,
            __btn_id2: className,
            __btn_type: 'common',
            __bth_only_ef: true,
        });
    };
    return (
        <div className={`${styles.OnePicture} one-picture GtmModuleData-section`} id="OnePicture" data-section-id="d3m-one-picture">
            <div className="content">
                {items.map((item, index) => (
                    <div
                        key={index}
                        className={`g-item g${index + 1} GtmModuleData-btn-common d3m-one-picture-${index}`}
                        style={{ gridArea: `g${index + 1}` }}
                        data-btn-id={`d3m-one-picture-${index}`}
                        onClick={() => handleScrollInToView(item.href || '', `d3m-one-picture-${index}`)}
                    >
                        <EcoImg pc={item.pc} pad={item.pc} h5={item.h5} isOpenLazy={true} />
                        <div className="title-wrapper">
                            <div className="title">{item.title}</div>
                            <div className="desc">{item.desc}</div>
                        </div>
                        {item.href && (
                            <div className="arrow">
                                <Arrow />
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default OnePicture;
